<template>
  <div :class="containerClass" :style="{display: fullWidth? 'flex':'unset'}">
    <div
        :class="`wrapper-controller${fullWidth ? ' full':''}`"
        :style="{marginTop: `${dense=== true ? '0' : '8px'}`}"
    >
      <div class="input-header">
        <div
            class="input-header__left"
            :style="{
              borderTopLeftRadius: `${borderRadius}px`,
              width: `${borderRadius*2}px`,
              height: `${borderRadius*2}px`,
              padding: `${borderRadius}px`,
              flexGrow: `${centerLabel ? '1': 'unset'}`
            }"
        ></div>
        <div class="input-header__center" :style="{alignItems: 'end' }">
          <span class="input-header__center--label">{{ label }}</span>
          <v-tooltip v-if="info.length>0" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  size="1em"
                  color="blue"
                  class="input-info"
              >
                fas fa-info-circle
              </v-icon>
            </template>
            <span>{{ info }}</span>
          </v-tooltip>
        </div>
        <div
            class="input-header__right"
            :style="{
              borderTopRightRadius: `${borderRadius}px`,
              width: `${borderRadius*2}px`,
              height: `${borderRadius*2}px`,
              padding: `${borderRadius*2}px`
            }"
        ></div>
      </div>
      <div class="input-body">
        <div
            :class="fullWidth ? 'input-body__slot--full':'input-body__slot'"
            :style="{flexWrap: flex ? 'wrap':'nowrap'}"
        >
          <slot/>
        </div>
      </div>
      <div
          class="input-footer"
          :style="{
              borderBottomLeftRadius: `${borderRadius}px`,
              borderBottomRightRadius: `${borderRadius}px`,
              height: `${borderRadius}px`
            }"
      ></div>
    </div>
  </div>
</template>
<script>
import vuetify from "@/plugins/vuetify";

/**
 * @component InputWrapper
 * UI wrapper/container component to mimic the
 * style and behavior of Vuetify input fields with label
 * when not available in framework's API
 */
export default {
  name: 'InputWrapper2',
  props: {
    label: {
      type: String,
      default: ''
    },
    centerLabel: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: ''
    },
    borderRadius: {
      type: Number,
      default: 4
    },
    containerClass: {
      type: String,
      default: '',
    },
    dense: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    flex: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    vuetify() {
      return vuetify
    }
  },
}
</script>

<style scoped lang="scss">
$border-color: #4ABD96;

.wrapper-controller {
  position: relative;
  //padding: 7px 6px;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  //max-width: 300px;
  width: max-content;

  &.full {
    display: flex;
    flex-grow: 1;
  }

  .input-header {
    display: flex;
    flex-direction: row;
    //justify-content: space-between;
    justify-content: left;
    width: 100%;
    height: 7px;

    &__left {
      border-left: 1px solid $border-color;
      border-top: 1px solid $border-color;
      //background-color: red;
      //flex-grow: 1;
    }

    &__center {
      display: flex;
      align-content: center;
      align-items: baseline;
      text-align: center;
      //padding: 4px 8px;
      //flex-grow: 1;
      font-size: 0.7em;
      opacity: 0.7;
      margin: -12px 2px 0;

      &--label {
        display: flex;
        //margin-top: -8px;
        cursor: default;
      }
    }

    &__right {
      border-right: 1px solid $border-color;
      border-top: 1px solid $border-color;
      flex-grow: 1;
    }
  }

  .input-info {
    margin-left: 2px;
    align-self: baseline;
  }

  .input-body {
    border-left: 1px solid $border-color;
    border-right: 1px solid $border-color;
    padding: 0 6px;

    &__slot {
      min-width: max-content;
    }

    &__slot--full {
      display: flex;
      column-gap: 4px;
      align-items: center;
      width: 100%;
    }
  }

  .input-footer {
    border-left: 1px solid $border-color;
    border-right: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
  }
}
</style>